import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

/**
 * Reusable confirmation dialog for destructive actions. Always name the
 * specific thing being removed in `title` — no bare "Are you sure?".
 *
 * <ConfirmDialog
 *   open={open}
 *   title="Remove Goblin from your library?"
 *   description="This can't be undone."
 *   confirmLabel="Remove"
 *   onConfirm={...}
 *   onCancel={...}
 * />
 */
export function ConfirmDialog({ open, title, description, confirmLabel = 'Remove', cancelLabel = 'Cancel', onConfirm, onCancel }) {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            {description ? (
                <DialogContent>
                    <DialogContentText>{description}</DialogContentText>
                </DialogContent>
            ) : null}
            <DialogActions>
                <Button onClick={onCancel}>{cancelLabel}</Button>
                <Button onClick={onConfirm} color="error" variant="contained">{confirmLabel}</Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
